"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MomentsGrid = void 0;

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../../util/helpers");

var _atoms = require("../../atoms");

var _MomentPreviewCell = require("../MomentPreviewCell");

var _ = require("../../");

require("./MomentsGrid.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MomentsGrid = /*#__PURE__*/function (_Component) {
  _inherits(MomentsGrid, _Component);

  var _super = _createSuper(MomentsGrid);

  function MomentsGrid() {
    var _this;

    _classCallCheck(this, MomentsGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentIdx: 0
    });

    return _this;
  }

  _createClass(MomentsGrid, [{
    key: "onVisibilityChange",
    value:
    /**
     * Do video auto playback on visibility of the video preview
     * If the preview is fully visible we start playing the video
     * If more than one preview is fully visible we start the first full one in the list.
     * @param e
     */
    function onVisibilityChange(e) {
      //Auto playback on visibility is available on mobile only
      if (!(0, _helpers.isMobileScreen)()) return;
      var list = this.visibleVideos || [];
      list.sort(function (a, b) {
        return a.index - b.index;
      });
      var current = list.length > 0 ? list[0] : {
        index: -1
      };

      if (e.event.intersectionRatio !== 1) {
        e.video.pause();
        list = list.filter(function (item) {
          return item.index !== e.index;
        });
      } else {
        list.push(e);
      }

      list.sort(function (a, b) {
        return a.index - b.index;
      });
      var next = list.length > 0 ? list[0] : {
        index: -2
      }; //console.log(`VIDEO PLAYER: ${current.index} -> ${next.index}`);

      if (current.index !== next.index) {
        if (current.video) current.video.stop();
        if (next.video) next.video.play();
        (0, _.trk)("MomentPreview:Hover over video:VideoPlay", true);
      }

      this.visibleVideos = list;
    }
  }, {
    key: "onPrevious",
    value: function onPrevious(e) {
      if (e) e.preventDefault();
      var showEntries = this.props.showEntries || 9;
      var idx = this.state.currentIdx - showEntries;
      console.log("Prev page", idx, this.props.clips.length);

      if (idx <= 0) {
        idx = 0;
      } else {
        if (idx > this.props.clips.length) idx = this.props.clips.length - showEntries;
      }

      this.setState({
        currentIdx: idx
      });
      document.querySelector('.bottom-content').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, {
    key: "onNext",
    value: function onNext(e) {
      if (e) e.preventDefault();
      var showEntries = this.props.showEntries || 9;
      var idx = this.state.currentIdx + showEntries;
      console.log("NEXT page", idx, this.props.clips.length);

      if (idx >= this.props.clips.length - 1) {
        idx = 0;
      } else {
        if (idx > this.props.clips.length) idx = this.props.clips.length - showEntries;
      }

      this.setState({
        currentIdx: idx
      });
      document.querySelector('.bottom-content').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var idx = this.state.currentIdx;
      var showEntries = this.props.showEntries || 9;
      var clips = this.props.clips.slice(idx, idx + showEntries);
      var prevTitle = this.props.prevTitle || "Previous Moments";
      var nextTitle = this.props.nextTitle || "Next Moments";
      return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        className: "moments-grid-content"
      }, clips.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
          className: "item-container",
          key: "mom-preview-".concat(item.game_clip_id)
        }, /*#__PURE__*/_react.default.createElement(_MomentPreviewCell.MomentPreviewCell, {
          moment: item,
          onMomentClick: function onMomentClick(m) {
            if (_this2.props.openMoment) _this2.props.openMoment(m);
          },
          index: index,
          onVisibilityChange: function onVisibilityChange(e) {
            return _this2.onVisibilityChange(e);
          },
          utmCampaign: _this2.props.utmCampaign,
          utmSource: _this2.props.utmSource,
          utmMedium: _this2.props.utmMedium
        }));
      }), /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        className: "arrow",
        onClick: function onClick(e) {
          return _this2.onPrevious(e);
        },
        marginRight: "1"
      }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
        type: _atoms.Icon.Type.ArrowLeft,
        size: 16
      }), prevTitle), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        className: "arrow",
        onClick: function onClick(e) {
          return _this2.onNext(e);
        },
        marginLeft: "1"
      }, nextTitle, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
        type: _atoms.Icon.Type.ArrowRight,
        size: 16
      }))));
    }
  }]);

  return MomentsGrid;
}(_react.Component); // export const MomentsGrid = (props) => {
//     const [currentIdx, setCurrentIdx] = useState(0);
//
//     /**
//      * Do video auto playback on visibility of the video preview
//      * If the preview is fully visible we start playing the video
//      * If more than one preview is fully visible we start the first full one in the list.
//      * @param e
//      */
//     const onVisibilityChange = (e) => {
//         //Auto playback on visibility is available on mobile only
//         if(!isMobile()) return;
//         let list = this.visibleVideos || [];
//         list.sort((a, b) => a.index - b.index);
//         let current = list.length > 0 ? list[0] : {index: -1};
//         if(e.event.intersectionRatio !== 1) {
//             e.video.pause();
//             list = list.filter(item => item.index !== e.index);
//         } else {
//             list.push(e);
//         }
//         list.sort((a, b) => a.index - b.index);
//         let next = list.length > 0 ? list[0] : {index: -2};
//         //console.log(`VIDEO PLAYER: ${current.index} -> ${next.index}`);
//         if(current.index !== next.index) {
//             if(current.video) current.video.stop();
//             if(next.video) next.video.play();
//         }
//         this.visibleVideos = list;
//     }
//
//     const onNext = (e) => {
//         if(e) e.preventDefault();
//         const showEntries = props.showEntries || 9
//         let idx = currentIdx;
//         if(idx === props.clips.length)
//         {
//             idx = 0;
//         } else {
//             idx += showEntries;
//             if(idx > props.clips.length) idx = props.clips.length - showEntries;
//         }
//         setCurrentIdx(idx)
//         window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
//     }
//
//     const idx = currentIdx;
//     const showEntries = props.showEntries || 9
//     const clips = props.clips.slice(idx, idx + showEntries);
//     const nextTitle = props.nextTitle || "Next Moments";
//
//     return (
//         <Element className="moments-grid-content">
//             {
//                 clips.map((item, index) => {
//                     return (
//                         <Element className="item-container" key={`mom-preview-${item.game_clip_id}`}>
//                             <MomentPreviewCell
//                                 moment={item}
//                                 onMomentClick={m => { if(props.openMoment) props.openMoment(m) }}
//                                 index={index}
//                                 onVisibilityChange={e=>onVisibilityChange(e)}
//                             />
//                         </Element>
//                     )})
//             }
//             <a href="." className="next" onClick={e=>onNext(e)}>{nextTitle} <Icon type={Icon.Type.ArrowRight} size={16}/>
//             </a>
//         </Element>
//     );
// }


exports.MomentsGrid = MomentsGrid;
var _default = MomentsGrid;
exports.default = _default;